import { Features } from "./features";

let featureMap: any = null;


export interface Feature {
    key: string;
    default: boolean;
    bereiche: Record<string, boolean>;
    addBereich: (bereich: string, value: boolean) => Feature; // Gibt Feature zurück
    check: (bereich: string) => boolean; 
}


export function hasFeature(feature_key: string, bereich_key: string) {
    if(!featureMap) {
        buildFeatureMap();
    }
    if(!bereich_key) {
         console.log('!!! Missing bereich: ' + feature_key+ '!!!');
        // Immer true
        return true;   
    }
    if(!featureMap[feature_key]) {
        console.log('!!! Missing feature definition: ' + feature_key+ '!!!');
        // Immer true
        return true;
    }
    return featureMap[feature_key].check(bereich_key);
}
function buildFeatureMap() {
    // Todo:
    // Später entweder aus JSON-Laden
    // Und / Oder einen Editor vorsehen, mit dem man die JSON-Datei bzw. Featuremap bearbeiten kann
    featureMap = {}; // Wird von "buildFeature" befüllt
    buildFeature(Features.ALTERNATIVES_SYSTEM, false).addBereich('handwerk' ,true);
    buildFeature(Features.CO2_AUSWERTUNG_ANTEIL_STANDORTE, false).addBereich('kommunalverwaltung' ,true);
    buildFeature(Features.CO2_SCOPE3_REISEN_TITEL, true).addBereich('kommunalverwaltung' ,false);
    buildFeature(Features.DV_GEWERKEGRUPPEN, true).addBereich('kommunalverwaltung' ,false).addBereich('privat', false);
    buildFeature(Features.STANDORT_GRUPPEN, false).addBereich('kommunalverwaltung' ,true);

}
// Todo: für Feature noch eine Klasse bauen
function buildFeature(key: string, defaultValue: boolean) {
    const feature = {} as Feature;
    feature.key = key;
    feature.default = defaultValue;
    feature.bereiche = {} as any;
    feature.addBereich = (bereich: string, value: boolean) => {
        feature.bereiche[bereich] = value;
        return feature; // Builder-Pattern
    }
    feature.check = (bereich: string) => {
        // Wenn false oder true explizit gesetzt sind ...
        if(feature.bereiche[bereich] === false) { return false; }
        if(feature.bereiche[bereich] === true) { return true; }
        // ... ansonsten default
        return feature.default; 
    }
    featureMap[key] = feature;
    return feature;
}
